// src/ForexHeatmapPage.js
import React from 'react';
import ForexHeatmap from './componets/ForexHeatmap';
import './HeatmapPage.css';

function ForexHeatmapPage() {
  return (
    <div className="heatmap-page">
      <h1>Forex Market Heatmap</h1>
      <div className="heatmap-container">
        <ForexHeatmap />
      </div>
    </div>
  );
}

export default ForexHeatmapPage;
